import MenuServiceDocs from '../MenuServiceDocs';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { FrameworkActionCreator, ROHistoryActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    specData: state.Specs.specs,
    specProfile: state.Framework.specProfile,
    selectedVehicle: state.Vehicles.selectedVehicle !== undefined ? state.Vehicles.selectedVehicle : '',
    vehicles: state.Vehicles.vehicles,
    theme: state.Framework.theme,
    colorSensitiveEnabled: state.Framework.colorSensitiveEnabled,
    customer: state.Customer.Customer,
    repairOrders: state.RepairOrders,
    loadVin: state.Framework.loadVin,
    loadRO: state.Framework.loadRO,
    serviceDocsSpecs: state.Specs.serviceDocsSpecs,
    newTabUrl: state.Framework.newTabUrl,
    store: state.Framework.store,
    branch: state.Framework.branch,
    previewFlag: state.Framework.previewFlag,
    locale: state.Framework.locale,
    roHistory: state.ROHistory.allRoHistory.roHistory,
    roHistoryBuilt: state.ROHistory.allRoHistory.built,
    portalLaunched: state.Framework.portalLaunched ? state.Framework.portalLaunched : '',
    eApprovalLaunched: state.Framework.eApprovalLaunched ? state.Framework.eApprovalLaunched : '',
    showMenu: state.Framework.previewFlag === 'p' ||
        (!state.Specs.serviceDocsSpecs?.osdVerifyIdentityFlag ?? false) || state.Customer.identityVerified,
    Itype: state.Framework.ImageServerType,
});

const mapDispatchToProps = {
    generateDocsUrl: FrameworkActionCreator.generateDocsUrl,
    clearNewTabUrl: FrameworkActionCreator.clearNewTabUrl,
    getDocsROHistory: ROHistoryActionCreator.GetDocsROHistory,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MenuServiceDocs);